<div class="confirmation-modal-container display-flex flex-column">
  <div mat-dialog-title class="display-flex justify-content-space-between">
    <h4 class="flex-1">
      <ng-container *ngIf="userGroupType.value === this.VendorEmployeeType.VendorAndEmployee; else addVendor">
        Add vendor and employee
      </ng-container>
      <ng-template #addVendor>Add vendor</ng-template>
    </h4>
    <ng-container [ngTemplateOutlet]="userType"></ng-container>
  </div>
  <mat-dialog-content [class.with-border]="userGroupType.value === VendorEmployeeType.Vendor">
    <ng-template #userType>
      <div class="flex-30">
        <app-radio-button-dropdown
          class="flex-grow-1"
          [containerCss]="'w-100'"
          [items]="vendorEmployeeToggleOptions"
          [labelRequired]="true"
          [allowClear]="false"
          [allowSearch]="false"
          [autoSortList]="false"
          [showValidationError]="false"
          [formControl]="userGroupType"
          [optionCss]="'inspection-format-option'"
          [placeholderCss]="'width-183'"
          [displaySkeleton]="isLoading"
          attrAppendTo="body"></app-radio-button-dropdown>
      </div>
    </ng-template>
    <div class="display-flex flex-column grid-gap-16 ng-star-inserted" *ngIf="form">
      <ng-container *ngIf="userGroupType.value === VendorEmployeeType.VendorAndEmployee">
        <app-divider [text]="'Vendor'"></app-divider>
      </ng-container>
      <div class="display-flex grid-gap-16">
        <app-input
          class="w-100"
          [attrLabel]="'Company'"
          [contentCss]="'display-flex flex-column fill'"
          [formControl]="company"
          [showValidationError]="formSubmitted"
          [attrPlaceholder]="'Enter company name'"
          [displaySkeleton]="isLoading"
          [labelRequired]="true"></app-input>
      </div>
      <ng-container *ngIf="userGroupType.value === VendorEmployeeType.VendorAndEmployee">
        <app-divider [text]="'Employee'"></app-divider>
        <div class="display-flex grid-gap-16">
          <app-input
            class="w-50"
            [attrLabel]="'First name'"
            [contentCss]="'display-flex flex-column fill'"
            [formControl]="firstName"
            [showValidationError]="formSubmitted"
            [attrPlaceholder]="'Enter first name'"
            [displaySkeleton]="isLoading"
            [labelRequired]="true"></app-input>
          <app-input
            class="w-50"
            [attrLabel]="'Last name'"
            [contentCss]="'display-flex flex-column fill'"
            [formControl]="lastName"
            [showValidationError]="formSubmitted"
            [attrPlaceholder]="'Enter last name'"
            [displaySkeleton]="isLoading"
            [labelRequired]="true"></app-input>
        </div>
        <div class="display-flex flex-column grid-gap-4">
          <div>
            <div class="display-flex grid-gap-16">
              <div class="w-50">
                <app-input
                  [attrLabel]="'Email'"
                  [contentCss]="'display-flex flex-column fill'"
                  [formControl]="email"
                  [showValidationError]="formSubmitted"
                  [attrPlaceholder]="'Enter email'"
                  [displaySkeleton]="isLoading"
                  (blurEvent)="onEmailBlur()"></app-input>
                <ng-container *ngIf="formSubmitted">
                  <ng-container *ngIf="emailAddedAsIdentity.value && !email.value; else emailDefaultErrors">
                    <app-input-error
                      [visible]="true"
                      [errors]="{
                        emailAddedAsIdentity: true
                      }"></app-input-error>
                  </ng-container>
                  <ng-template #emailDefaultErrors>
                    <app-input-error class="w-50" [visible]="true" [errors]="form.errors"></app-input-error>
                  </ng-template>
                </ng-container>
              </div>

              <app-phone-number-input
                class="w-50"
                [attrLabel]="'Phone Number'"
                [defaultCode]="1"
                [showValidationError]="formSubmitted"
                [formControl]="phoneNumber"
                [displaySkeleton]="isLoading"
                [phoneNumberAsIdentity]="phoneNumberAddedAsIdentity.value"
                (phoneNumberInvalid)="phoneNumberInvalid = $event"></app-phone-number-input>
            </div>
          </div>
          <div class="display-flex grid-gap-16">
            <div class="w-50 display-flex align-items-center grid-gap-6">
              <mat-checkbox *ngIf="!isLoading" color="primary" [formControl]="emailAddedAsIdentity">
                <span class="warning-message">Register email as user login</span>
              </mat-checkbox>
              <ng-container>
                <div class="skeleton-loader" *ngIf="isLoading"></div>
              </ng-container>
            </div>
            <div class="w-50 display-flex align-items-center grid-gap-6">
              <mat-checkbox *ngIf="!isLoading" color="primary" [formControl]="phoneNumberAddedAsIdentity">
                <span class="warning-message">Register phone number as user login</span>
              </mat-checkbox>
              <ng-container>
                <div class="skeleton-loader" *ngIf="isLoading"></div>
              </ng-container>
            </div>
          </div>
        </div>
        <div class="display-flex flex-fill grid-gap-16">
          <app-select-tree
            *ngIf="data.withPortfolioPropertiesSelector"
            class="w-100"
            [label]="'Portfolio/Properties'"
            (selectedRoots)="selectedRootsChange($event)"
            [nodes]="allProperties$ | async"
            [selectedNodes]="allProperties$ | async"
            [warningMessage]="warningMessage"
            [displaySkeleton]="isLoading"
            [showValidationError]="formSubmitted"></app-select-tree>
        </div>
      </ng-container>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <div class="display-flex grid-gap-8 justify-content-end w-100">
      <button mat-stroked-button color="warn" class="modal-button" (click)="cancel()">Cancel</button>

      <button mat-raised-button color="primary" class="modal-button" [disabled]="inProgress$ | async" (click)="send()">
        <div class="display-flex align-items-center grid-gap-4">
          {{ data.onlyAddBtn ? 'Add' : ' Add and Assign' }}
          <mat-spinner *ngIf="inProgress$ | async" color="accent" diameter="20"></mat-spinner>
        </div>
      </button>
    </div>
  </mat-dialog-actions>
</div>
